import { render, staticRenderFns } from "./FloorCard.vue?vue&type=template&id=68d8c840"
import script from "./FloorCard.vue?vue&type=script&lang=js"
export * from "./FloorCard.vue?vue&type=script&lang=js"
import style0 from "./FloorCard.vue?vue&type=style&index=0&id=68d8c840&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports